import { Component, EventEmitter, Input, Output } from '@angular/core';
import { XeroInvoiceRow } from '../../../services/response/xero/xero-invoice-row';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { DateLocalFormatPipe } from '../../../pipes/date-local-format.pipe';

@Component({
   selector: 'app-billing-history',
   templateUrl: './billing-history.component.html',
   standalone: true,
   imports: [TableModule, TagModule, CommonModule, DateLocalFormatPipe],
   styleUrls: ['./billing-history.component.scss']
})
export class BillingHistoryComponent {
   @Input() invoices: XeroInvoiceRow[] = [];
   @Input() loading = false;
   @Output() download = new EventEmitter<{
      invoice: XeroInvoiceRow;
      download: boolean;
   }>();

   trackById = (_: number, row: XeroInvoiceRow) => row.invoiceId;
}
